// PageProducts.js
import React, { useState, useEffect } from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
//import { useNavigation } from '@react-navigation/native';
import { useNavigate } from 'react-router-dom';
import NavBar from './navBar';
import MenuPanel from './menuPanel';
import Item from './lib/item'
import productType from './lib/productType'
import productTypeList from './lib/productTypeList';

const PageProducts = () => {
  //const navigation = useNavigation();
const navigate = useNavigate();
  const [itemsList, setItemsList] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    try {
      const response = await fetch('/proxy.php'); // URL del server proxy
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json(); // Leggi i dati JSON restituiti dal server
      console.log(jsonData); // Stampa i dati

      //const result = await response.json(); // Supponendo che il server restituisca JSON
      setData(jsonData); // Aggiorna lo stato con i dati ricevuti
      console.log('Request sent successfully');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const items = [];
  // Cicla attraverso ogni riga del risultato
  console.log("data " + data);
  data.forEach((row) => {
    // Crea un nuovo oggetto Item per ogni riga
    const id = row.productTypeList;
    const type = productTypeList[id];

    const newItem = new Item(
      type,  // prodotto (modifica se necessario)
      row.numberS,      // quantità per taglia S
      row.numberM,      // quantità per taglia M
      row.numberL       // quantità per taglia L
    );

    // Aggiungi l'oggetto Item alla lista
    console.log("i dati sono new item: " + newItem);
    items.push(newItem);
  });
  const handleSeeProduct = (currentItem) => {
   // navigate("/product", { state: { currentItem } });

   //console.log("i dati sono new item: " + currentItem);
  // const currentItem = new Item(currentItem.productType, currentItem.quantityS ,currentItem.quantityM, currentItem.quantityL,);
  navigate(`/PageProducts/product/${currentItem.productType.id}`, { state: { currentItem } });

  };
  //dati moccati------------
  // const newItem2 = new Item(
  //   productTypeList[0],  // prodotto (modifica se necessario)
  //   0,      // quantità per taglia S
  //   20,      // quantità per taglia M
  //   10      // quantità per taglia L
  // );

  // // Aggiungi l'oggetto Item alla lista
  // items.push(newItem2);
  // const newItem1 = new Item(
  //   productTypeList[1],  // prodotto (modifica se necessario)
  //   10,      // quantità per taglia S
  //   0,      // quantità per taglia M
  //   20       // quantità per taglia L
  // );

  // // Aggiungi l'oggetto Item alla lista
  // items.push(newItem1);
  //------------


  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);

  return (
    <View style={styles.container}>
      {/* NavBar with Menu Button */}
      <NavBar toggleMenu={toggleMenu} />
      <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />
      <ScrollView style={styles.header}>
        {/* Main Content */}
        <Text style={styles.title}>Felpe</Text>


        <ScrollView style={styles.scrollContainer}>
          <View style={styles.innerView}>
            {items.map(item => (
              <TouchableOpacity key={item.productType.id} onPress={() => handleSeeProduct(item)} style={styles.productContainer}>
                <Image source={item.productType.imgPath1} style={styles.image} />
                <View style={{ alignItems: 'left', marginLeft: -50 }}>
                  <Text style={styles.productName}>{item.productType.name}</Text>
                  <Text style={styles.productPrice}>€ {item.productType.price.toFixed(2)}</Text>
                </View>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
  },
  header: {
    flex: 1,
    padding: 20,
    marginTop: 60,
    padding: 10,
    backgroundColor: '#FFFFFF',
  },
  title: {
    fontSize: 20,
    fontWeight: '300',
    textAlign: 'start',
    padding: 10,
  },
  scrollContainer: {
    flex: 1,
  },
  innerView: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  productContainer: {
    width: '50%',
    height: 250,
    marginBottom: 20,
    backgroundColor: '#fff',
    alignItems: 'center',
  },
  image: {
    width: 200,
    height: 200,
    resizeMode: 'contain',
  },
  productName: {
    fontSize: 12,
    fontWeight: '300',
  },
  productPrice: {
    fontSize: 12,
    fontWeight: '100',
    paddingBottom: 5,
  },


  contentButton: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
  },
  thumbnail: {
    width: 70,
    height: 70,
    borderRadius: 10,
    marginRight: 12,
  },
  text: {
    fontSize: 16,
    color: "#333",
    fontWeight: "bold",
  },
  icons: {
    fontSize: 16,
  },
  button: {
    backgroundColor: "#D97B33", // Colore del pulsante
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  buttonText: {
    fontSize: 16,
    color: "#FFF",
    fontWeight: "bold",
  },
});

export default PageProducts;
